export interface StorePaths {
  base: string;
  home: string;
  orderManagement: string;
  shipping: string;
  returns: string;
  inventory: string;
  catalog: string;
  marketing: string;
  support: string;
  supportV2: string;
  faq: string;
  conversion: string;
  customers: string;
  payments: string;
  redoSupplies: string;
  aeo: string;
  analytics: string;
  developer: string;
  settings: string;
  commerceAgent: string;
}

/** Pure store-scoped URL prefixes. No team, flag, or permission state. */
export function storePaths(storeBase: string): StorePaths {
  const supportV2 = `${storeBase}/support-v2`;
  return {
    base: storeBase,
    home: `${storeBase}/home`,
    orderManagement: `${storeBase}/order-management`,
    shipping: `${storeBase}/shipping`,
    returns: `${storeBase}/returns`,
    inventory: `${storeBase}/inventory`,
    catalog: `${storeBase}/catalog`,
    marketing: `${storeBase}/marketing`,
    support: `${storeBase}/support`,
    supportV2,
    faq: `${supportV2}/faq`,
    conversion: `${storeBase}/conversion`,
    customers: `${storeBase}/customer`,
    payments: `${storeBase}/payments`,
    redoSupplies: `${storeBase}/redo-supplies`,
    aeo: `${storeBase}/aeo`,
    analytics: `${storeBase}/analytics`,
    developer: `${storeBase}/developer`,
    settings: `${storeBase}/settings`,
    commerceAgent: `${storeBase}/commerce-agent`,
  };
}
